"use client";
import { useState, useEffect } from "react";

import ForgotPasswordForm from "src/components/login/forgot-password-form";
import { LazyImage } from "components/common/lazy-image/LazyImage";

import styles from "./styles.module.css";

const ForgotPasswordScreen = () => {
  const [forgotFormMail, setForgotFormMail] = useState("");

  useEffect(() => {
    const email = localStorage.getItem("forgot-password-user");
    setForgotFormMail(email);
  }, []);
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.form}>
          <div className={styles.loginForm}>
            <ForgotPasswordForm defaultMail={forgotFormMail} />
          </div>
        </div>
        <div className={styles.form}>
          <LazyImage src="/assets/images/login-photo-crop.png" className={styles.formImage} alt="Emlakjet - Giriş" />
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordScreen;
